// extracted by mini-css-extract-plugin
export default {"contentField":"styles_contentField__OU9nv","content":"styles_content__U+SHt","faded":"styles_faded__rqhNO"};